<template>
    <div class="search_main">
        
        <div class="search_box">

            <a-radio-group v-model="searchP.actiontype" @change="onTypeChange" style="float:left;">
                <a-radio :style="radioStyle" value="quick">
                快速查询
                </a-radio>
                <a-radio :style="radioStyle" value="sql">
                sql查询
                </a-radio>
            </a-radio-group>

            <editor  v-model="searchP.sql" @init="editorInit" :lang="currentLanguage" theme="chrome"
                width="800" :height="sqlHeight" class="search_input" style="border-radius:0;"></editor>

            <a-popover v-model="rangevisible" trigger="click" placement="bottom" class="search_range">
                <template slot="title">
                    <a-input v-model="searchTimeRange" placeholder="" class="date_input date_content" />
                </template>
                <template slot="content">
                    <div class="date_content">
                        <a-button type="link" @click="handleTime(7)">1分钟</a-button>
                        <a-button type="link" @click="handleTime(8)">5分钟</a-button>
                        <a-button type="link" @click="handleTime(9)">1小时</a-button>
                        <a-button type="link" @click="handleTime(1)">今天</a-button>
                        <a-button type="link" @click="handleTime(2)">昨天</a-button>
                        <a-button type="link" @click="handleTime(3)">本周</a-button>
                        <a-button type="link" @click="handleTime(4)">上周</a-button>
                        <a-button type="link" @click="handleTime(5)">本月</a-button>
                        <a-button type="link" @click="handleTime(6)">上月</a-button>
                        <a-button type="link" @click="handleTime(100)">自定义</a-button>

                    </div>
                </template>
                <a-button type="normal" style="color:#0070cc" :title="searchTimeRange">
                    {{dateTypeTitle}}
                    <a-icon type="down" style="color: #0070cc" />
                </a-button>
            </a-popover>
            <a-button v-if="logstorename" type="primary" @click="handleSearch" class="search_submit">执行查询</a-button>
            <a-button v-if="logstorename" type="normal" @click="handleSaveSql" class="search_submit">保存语句</a-button>
            <LogSqlAdd :project="projectname" :querystr="searchP.sql" :visible="sqlAddVisible" @onSqlAddClose="handleSqlAddClose"></LogSqlAdd>
        </div>

        <div class="data_box">
                
            <div class="btn_block">

                <a-radio-group v-model="listMode" class="rangeBtnType" @change="showTable">
                    <a-radio-button value="table" >
                        表格
                    </a-radio-button>
                    <a-radio-button value="list">
                        原始
                    </a-radio-button>
                </a-radio-group>
                <div class="timeRevrseBtn" @click="handleReverseChange"> 
                    <span class="timeRevrseIconSpan">时间</span>
                    <div class="timeRevrseIconBox">
                        <a-icon type="caret-up"  :class="{timeRevrseBtnUp:true,active:!searchP.reverse}" />
                        <a-icon type="caret-down" :class="{timeRevrseBtnDown:true,active:searchP.reverse}" />
                    </div>
                </div>
                <a-button type="primary" style="margin-top:20px;" v-if="listMode=='table' && data.length > 0" @click="handleExport">导出数据</a-button>
                <!-- <div style="margin-top:22px;margin-left:10px;display:inline-flex">说明：仅提供前100条数据</div> -->
                <label v-if="listMode=='table'" for="" style="margin-top:18px;margin-left:10px;" >每页条数：</label>
                <a-input-number v-if="listMode=='table'" style="margin-top:20px;" v-model="searchP.pageSize" :min="1" :max="500" />
                <a-pagination  style="margin-left:20px;display:inline-flex;margin-top:20px;" v-model="searchP.current" :pageSize="searchP.pageSize" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />
            </div>
           

            <a-table bordered v-if="listMode=='table'" :components="components" :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" :rowKey="(record,index)=>{return index}" :scroll="{ x: 1200}"
            style="float:left;width:100%;border-bottom:none;">
            
            </a-table>

            <a-list v-else bordered :data-source="data" :loading="tLoading" style="min-height:100px;">
                <a-list-item slot="renderItem" slot-scope="item, index">
                    <div class="list_item_box">
                        <div class="list_item_head">
                            <span class="colom_index">{{index + 1}}</span>
                            <span class="colom_time">{{item.时间}}</span>
                        </div>
                        <div class="list_item_data">
                            <div class="list_item_data_item" v-for="(value,key,index) in item" :key="index">
                                <div class="list_item_data_item_key">{{key}}</div>
                                <span>:</span>
                                <span class="list_item_data_item_value">{{value}}</span>
                            </div>
                        </div>
                    </div>

                </a-list-item>
            </a-list>
        </div>
        
    </div>
</template>
<script>
import Editor from 'vue2-ace-editor'
import LogSqlAdd from './logsqladd'
import Vue from "vue";
import VueDraggableResizable from "vue-draggable-resizable";
import { export2Excel } from '../../../common/excel/util'
Vue.component("vue-draggable-resizable", VueDraggableResizable);



let searchP={
    current:1,
    total:0,
    pageSize:20,
    actiontype:'quick',
    sql:'businesscode:pos*',
    reverse:true,
};

export default {
    data() {
        return {
            components:null,
            columns:[],
            data:[],
            keys:[],
            currentLanguage:'sql',
            searchP,
            tLoading:false,
            rangevisible:false,
            sqlHeight:'64px',
            dateTypeTitle:'今天',
            dateTypeIndex:1,
            searchTimeRange:'',
            listMode:'list',
            radioStyle: {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
            },
            sqlAddVisible:false,
        };
    },
    props: {
        projectname: String,
        logstorename: String,
        logindex: Array,
    },
    methods: {
        handleExport(){
            let that = this;
            export2Excel(that.columns,that.data);
        },
        handleSqlAddClose(){
            this.sqlAddVisible = false;
        },
        handleSaveSql(){
            //起标题
            this.sqlAddVisible = true;
        },
        onTypeChange(e) {
            // searchP.actiontype =  e.target.value;
            if(e.target.value == 'sql'){
                this.searchP.sql = "* | select * from log where businesscode like '%pos%'"
            }
            else {
                this.searchP.sql = "businesscode:pos*"
            }
        },
        editorInit(editor) {
            editor.setOption("showLineNumbers",false)
            editor.setOption("showGutter",false)
            editor.setOption("displayIndentGuides",false)

            // require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/sql')  
            require('brace/mode/less')
            require('brace/theme/chrome')
        },
        handleReverseChange(){
            this.searchP.reverse = !this.searchP.reverse;
            this.handleSubmit()
        },
        // 分页事件
        handlePageChange(c){
            this.searchP.current = c;
            this.handleSubmit();
        },
        handleSearch(){
            this.searchP.current = 1;
            if(this.searchP.sql.indexOf('* |') != -1 && this.searchP.sql.indexOf('from log') == -1){
                this.message.info("SQL 查询需要加  from log 例如：* | select * from log where 1=1");
                return
            }

            this.handleSubmit();
        },
        handleSubmit(){
            let that = this;
            let timeRange = that.searchTimeRange.split('~');
            let starttime = (new Date(timeRange[0]).getTime())/1000;
            let endtime = (new Date(timeRange[1]).getTime())/1000;

            that.tLoading = true;
            let params = {
                projectname:that.projectname,
                logstorename:that.logstorename,
                starttime:starttime,
                endtime:endtime,
                sql:that.searchP.sql,
                pageSize:that.searchP.pageSize,
                offset:(that.searchP.current - 1) * that.searchP.pageSize,
                reverse:that.searchP.reverse,
                paged:true,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    
                    let result = res.data.data;
                    that.searchP.total = parseInt(result.count);
                    that.keys = result.keys;
                    that.data = result.list;
                    that.showTable();
                    if(result.list.length == 0){
                        that.message.info("查无数据");
                    }
                }
                that.tLoading = false;
            }).catch(() => {
                that.tLoading = false;
            });
        },
        showTable(){
            this.columns = [];
            if(this.listMode == 'table'){
                this.columns.push(
                    {
                        title: '#',
                        customRender: (text, record, index) => {
                            let { current, pageSize } = searchP;
                            return (Number(current) - 1) * Number(pageSize) + index + 1;
                        },
                        key: '#',
                        dataIndex: '#',
                        width:60,
                        align:'center'
                    }
                )
                //组装coloms
                for (let index = 0; index < this.keys.length; index++) {
                    const element = this.keys[index];
                    if(element.startsWith("__") && element.endsWith("__")){
                        continue
                    }
                    this.columns.push({
                        title: element,
                        key: element,
                        dataIndex: element,
                        width:180
                    })
                }
                let that = this;
                const draggingMap = {};
                that.columns.forEach((col) => {
                    draggingMap[col.key] = col.width;
                });
                const draggingState = Vue.observable(draggingMap);

                const resizeableTitle = (h, props, children) => {
                    let thDom = null;
                    const { key, ...restProps } = props;
                    const col = that.columns.find((col) => {
                        const k = col.dataIndex || col.key;
                        return k === key;
                    });
                    if (!col.width) {
                        return <th {...restProps}>{children}</th>;
                    }
                    const onDrag = (x) => {
                        draggingState[key] = 0;
                        col.width = Math.max(x, 1);
                    };
                    const onDragstop = () => {
                        draggingState[key] = thDom.getBoundingClientRect().width;
                    };
                    return (
                        <th
                            {...restProps}
                            v-ant-ref={(r) => (thDom = r)}
                            width={col.width}
                            class="resize-table-th"
                        >
                            {children}
                            <vue-draggable-resizable
                                key={col.key}
                                class="table-draggable-handle"
                                w={10}
                                x={draggingState[key] || col.width}
                                z={1}
                                axis="x"
                                draggable={true}
                                resizable={false}
                                onDragging={onDrag}
                                onDragstop={onDragstop}
                            ></vue-draggable-resizable>
                        </th>
                    );
                };

                this.components = {
                    header: {
                        cell: resizeableTitle,
                    },
                };
            }
            else{
                console.log(this.listMode)

            }
 
        },

        hide() {
            this.rangevisible = false;
        },

        handleTime(t){
            let cRange = {};
            if(t != 100){
                cRange = this.G.getRecentDate(t)
                this.dateTypeTitle = cRange.title;
                this.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.hide();

            }
            else{
                cRange = this.G.getRecentDate(7)
                this.searchTimeRange = cRange.start_time + '~' + cRange.end_time;
                this.dateTypeTitle = "自定义"
            }
            
        },


    },
    computed:{
        
    },
    components:{
        Editor,
        LogSqlAdd
    },
    mounted(){
        this.handleTime(1);
    }
};
</script>
<style scoped>

    .btn_block{
        width: 100%;
        height: 80px;
        display: inline-block;
    }
    .rangeBtnType{
        float: left;
        margin: 20px 0;
    }
    .timeRevrseBtn{
        display: inline;
        width: 75px;
        padding: 0;
        height: 32px;
        border-radius: 4px;
        border:1px solid lightgray;
        margin: 20px 10px;        
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        float: left;
        cursor: pointer;

    }   
    .timeRevrseIconSpan{
        line-height: 30px;
        padding: 0 8px;
    }
    .timeRevrseIconBox{
        width: 20px;
        height: 25px;
        float: right;
        margin-top: 1px;
        margin-right: 4px;
    }

    .timeRevrseIconBox .active{
        color: #1890ff;
    }
    .timeRevrseBtnUp{
        float: left;
    }
    .timeRevrseBtnDown{
        float: left;
    }

    
    .list_item_box{
        width: auto;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 10px 13px;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
    }
    .list_item_head{

        padding-right: 5px;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -moz-box-orient: horizontal;
        -moz-box-direction: normal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        -moz-box-sizing: content-box;
        box-sizing: content-box;
    }
    .colom_index{
        color: #333;
        font-size: 12px;
        margin-top: 3px;
    }
    .colom_time{
        margin-top: 2px;
        margin-left: 10px;
        padding-right: 5px;
        font-weight: 700;
        color: #333;
        font-size: 12px;
        white-space: nowrap;
    }
    .list_item_data{
        flex: 1;
        box-sizing: border-box;
        display: block;
    }
    .list_item_data_item{
        font-family: Roboto Mono,Consolas,Menlo,Courier,monospace;
        display: block;
        word-break: break-word;
        word-wrap: break-word;
        line-height: 16px;
        margin-right: 5px;
    }
    .list_item_data_item_key{
        display: inline-flex;
        color: #333;
        font-size: 12px;
        background-color: rgba(0,86,144,.1);
        border-radius: 2px;
        padding: 1px 3px!important;
        margin: 2px 0;
    }



    .search_main{
        width:100%;
        height:100%;
        float: left;
    }
    .search_box{
        width: 100%;
        height: 100%;
        margin-top:20px;
        position: relative;
        float: left;
        background-color: #f6f5f7;
    }

    .data_box{
        width:100%;
        height: 100%;
        min-height: 650px;
        position: relative;
        float: left;

    }
    .search_type{
        float:left;
    }

    .search_type .ant-select-selection{
        border-radius: 0;
        border-right:none;
    }

    .search_range{
        float:left;
        margin-left:10px;
    }

    .search_input{
        float:left;
        font-size: 16px;
        border:1px solid lightgray;
        margin-left:10px;
    }

    .search_submit{
        float:left;
        margin-left:10px;
    }

    .sqllable{
        color: black;
        float: left;
    }

    .date_input{
        height: 22px;
        color: rgba(0,0,0,.65);
        background: #fff;
        outline: 0;
        cursor: auto;
    }

    .date_content{
        width: 300px;
    }


</style>

<style lang="less">
.resize-table-th {
  position: relative;
  .table-draggable-handle {
    transform: none !important;
    position: absolute;
    height: 100% !important;
    bottom: 0;
    left: auto !important;
    right: -5px;
    cursor: col-resize;
    touch-action: none;
  }
}
</style>